import '../App.css';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Highlightable, { Range } from 'highlightable';
import React from 'react';

function Document({...properties}) {

    return (
        <div id="textToRead" className='documentReader' onCopy={e => e.preventDefault()}>
            <Highlightable
                    ranges={properties.highlights}
                    enabled={false}
                    highlightStyle={{ backgroundColor: '#FDEAA3' }}
                    text={properties.passage}
                    nodeRenderer={(index, range, text) => {
                        var currChar = text.charAt(index);
                        if (currChar === '\n'){
                            return (<><br/><br/></>)
                        }
                        return (
                            <span className='hidden' data-position={index} range={range} data-text={currChar}></span>
                        )
                    }}
                    rangeRenderer={range => {
                        return (
                            <div style={{display: 'inline', position: 'relative'}}>
                                <span style={{outline: "2px solid #FDEAA3", backgroundColor: "#FDEAA3"}}>{range}</span>
                            </div>
                        );
                    }
                }/>
        </div>
    );
}

export default Document;